import moment from 'moment';

import api from '../../../lib/api/index';

export default {
  async getAll({ rootState, commit }, queries = {}) {
    const {
      filter,
      size,
      page,
      ...query
    } = queries;

    const { companyId: company } = rootState.auth;
    if (queries.download) {
      const invoices = await api.invoice.getAll(
        company,
        filter,
        page,
        size,
        query,
      );

      const url = URL.createObjectURL(invoices, {
        type: 'application/zip',
      });
      const download = document.createElement('a');
      const body = document.querySelector('body');

      download.setAttribute('href', url);
      download.setAttribute('download', 'documentos.zip');
      download.style.display = 'none';

      body.appendChild(download);

      download.click();

      return invoices;
    }
    const { invoices: list, totalRows: total, ...payload } = await api.invoice.getAll(
      company,
      filter,
      page,
      size,
      query,
    );

    commit('setValues', payload);
    commit('setValue', { accessor: 'list', value: list });
    commit('setValue', { accessor: 'total', value: total });
    commit('setValues', { queries });

    return payload;
  },

  async search({ state, rootState, commit }, payloadAction) {
    const {
      filters,
      isRep = null,
      size,
      page,
    } = payloadAction;

    const { companyId: company } = rootState.auth;

    const { invoices: list, totalRows: total, ...payload } = await api.invoices.search(
      company,
      filters,
      page,
      size,
      isRep,
    );

    const value = list.map(invoice => ({
      ...invoice,
      receiverName: invoice.cfdi.receiverName,
      receiverRfc: invoice.cfdi.receiverRfc,
      folio: `${invoice.cfdi.voucherSeries}-${invoice.cfdi.voucherConsecutive}`,
      uuid: invoice.cfdi.complement.digitalTaxStamp.uuid,
    }));

    commit('setValues', {
      ...payload,
      list: value,
      all: state.all.concat(
        value.filter(({ uuid }) => !state.all.some(({ uuid: exists }) => exists === uuid)),
      ),
      total,
    });

    return payload;
  },

  async downloadAll({ rootState }) {
    const { companyId: company } = rootState.auth;
    const payload = await api.invoices.getAllCsv(company);
    const body = document.querySelector('body');

    const download = document.createElement('a');
    const downloadUrl = URL.createObjectURL(payload);

    download.setAttribute('href', downloadUrl);
    download.setAttribute('download', 'cfdis.csv');
    download.style.display = 'none';

    body.appendChild(download);

    download.click();

    return 'cfdis.csv';
  },
  async getStatusAccount({ commit, rootState }, queries = {}) {
    const {
      size,
      page,
      token,
      ...query
    } = queries;

    const { companyId, customerId } = rootState.customers.temporal;

    const { invoices: list, totalRows: total, ...payload } = await api.invoice.getStatusAccount(
      companyId,
      customerId,
      page,
      size,
      query,
      token,
    );

    commit('setValues', payload);
    commit('setValue', { accessor: 'list', value: list });
    commit('setValue', { accessor: 'total', value: total });

    return payload;
  },
  async getDebtsInMonth({ commit }, query) {
    const now = moment();

    const { year, month = now.month() } = query;

    const correctMonth = month + 1;

    const {
      invoices: list,
      totalRows: total,
      ...payload
    } = await api.balances.getDebtsInMonth({ year, month: correctMonth });

    commit('setValues', payload);
    commit('setValue', { accessor: 'list', value: list });
    commit('setValue', { accessor: 'total', value: total });

    return payload;
  },
  async searchInvoices({ rootState }, queries = {}) {
    const {
      filter,
      size,
      page,
      ...query
    } = queries;

    const { companyId: company } = rootState.auth;

    const { invoices } = await api.invoice.getAll(
      company,
      filter,
      page,
      size,
      query,
    );

    return invoices;
  },
};
